<template>
  <div class="div-confirmation" v-if="isOrderLoaded">
    <header-component></header-component>
    <div class="container-fluid g-py-100">
      <div v-if="!isDataLoading" class="order-confirmation row">
        <div v-if="isOrderValid" class="col-lg-8 offset-lg-2">
          <div class="row">
            <div v-if="$route.params.isSummaryOnly == '1' && Order.orderStatus != 'Error'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
              <h2 class="">Congratulations!</h2>
              <p class="order-confimation-description">Your order has been submitted successfully.</p>
              <p class="order-confimation-description">
                Please print a copy of this for your records and include a copy along with your frame if you have placed a frame-to-come order.
              </p>
            </div>
            <div v-else-if="Order.orderStatus == 'Error'" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
              <p class="order-confimation-label">Error!</p>
              <p class="order-confimation-description">This order has an error.</p>
              <p class="order-confimation-description">
                Kindly contact the OneSight EssilorLuxottica Foundation team for more information
              </p>
            </div>
            <div v-if="isCoveredPaymentShown" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
              <p style="color:green; font-weight:bold">The voucher provided covers the payment amount for this order</p>
            </div>
            <div class="col-lg-12">
              <div class="row text-center">
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="GenerateHtml()">Print Exam Summary</button>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="NewOrder(Order.id)">Convert to Order</button>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="EditOrder(Order.id)">Edit</button>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                  <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10" v-on:click="ShowDeleteModal(Order.id)">Delete</button>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
              <div class="order-title">
                Participant and Order Information
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">Patient:</label>
                <span class="order-confimation-description">{{Order.patFirstName}} {{Order.patLastName}}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">Participant Name:</label>
                <span v-if="Account.accountType == 1" class="order-confimation-description">{{Account.primaryContact.firstName}} {{Account.primaryContact.lastName}} {{Account.primaryContact.suffix}}</span>
                <span class="order-confimation-description">{{Account.primaryContact.legalName}}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">Entry ID:</label>
                <span class="order-confimation-description">{{Order.id}}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">Examining Doctor:</label>
                <span class="order-confimation-description" v-if="doctor">{{doctor.lastName}}, {{doctor.firstName}}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">Submitted:</label>
                <span class="order-confimation-description">{{FormatDateToLocal(Order.dateSubmitted)}}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">Phone:</label>
                <span class="order-confimation-description">{{Account.primaryContact.phoneNumber | phone_format}}</span>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">&nbsp;</label>
                <span class="order-confimation-description">&nbsp;</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div class="form-group no-margin-bottom">
                <label class="order-confimation-label">Email:</label>
                <span class="order-confimation-description">{{Account.emailAddress}}</span>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
              <div class="order-title">
                Patient/Order Notes
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top">
              <div class="row no-gutters">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 border-box min-height-dispenser-notes">
                  <span>{{Order.dispenserNotes}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isOrderValid" class="col-lg-8 offset-lg-2">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
              <p class="error-message">Error!</p>
              <p class="order-confimation-description">
                Order requested is not valid.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isDataLoading" class="row margin-top">
        <page-loader></page-loader>
      </div>
    </div>
    <service-payment :Account="Account" :Order="Order" v-if="isServicePaymentShown" @close="isServicePaymentShown = false"></service-payment>
    <footer-component></footer-component>
    <prompt-component :message="promptMessage" v-if="isDeleteModelShown" @close="CloseDeleteModal()" @onAgree="DeleteOrder()"></prompt-component>
  </div>
</template>

<script>
  import HeaderComponent from "@/components/shared/HeaderComponent";
  import FooterComponent from "@/components/shared/FooterComponent";
  import PageLoader from "@/components/shared/PageLoader";
  import ServicePayment from "@/components/shared/ServicePayment";
  import VueBarcode from '@xkeshi/vue-barcode'
  import PromptComponent from "@/components/shared/PromptComponent";
  export default {
    components: {HeaderComponent, FooterComponent, PageLoader, VueBarcode, ServicePayment, PromptComponent},
    data(){
      return{
        Order:{},
        Account:{},
        isDataLoading:true,
        MasterAccountType: null,
        isServicePaymentShown:false,
        isCoveredPaymentShown:false,
        isOrderValid: false,
        isDeleteModelShown: false,
        idToDelete: 0,
        promptMessage: 'Deleting this entry will remove it from your records and Track Order page.  Would you like to delete?',
        isOrderLoaded: false,
        doctor: null,
      }
    },
    methods: {
      CloseDeleteModal(){
        this.isDeleteModelShown = false;
      },
      ShowDeleteModal(id){
        this.idToDelete = id;
        this.isDeleteModelShown = true;
      },
      GetOrderData(){
        var _this = this;
        axios.get('/Order/Get/' + this.$route.params.code, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
          .then(function (response) {
            if (response.data.isSuccess == false){
              _this.isDataLoading = false;
              _this.isOrderValid = false;
              _this.isOrderLoaded = true;
            }
            else{
              _this.isOrderValid = true;
              _this.isDataLoading = false;
              _this.Order = response.data.raw;
              _this.Account = response.data.raw.accountDetails;
              if (_this.Order.jobType == 'FTC')
              {
                if (_this.$route.params.isSummaryOnly == '1'){
                  _this.GenerateHtml();
                }
              }
              if(_this.Order.payment && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master'){
                _this.isCoveredPaymentShown = true;
              }else if (_this.Order.payment == false && _this.Order.orderPayment && _this.$route.params.isSummaryOnly == '1' && _this.MasterAccountType != 'master'){
                _this.isServicePaymentShown = true;
              }

              axios.post('/Account/EyeDoctor/GetEyeDoctor/' +  _this.Order.eyeDoctorId, _this.Account)
                .then(function (response) {
                  if(response.data.isSuccess == true){
                    _this.Account.eyeDoctors = response.data.raw;
                    _this.doctor = _this.Account.eyeDoctors.filter(a => a.salesforceId == _this.Order.eyeDoctorId)[0];
                    _this.isLoaded = true;


                    _this.isOrderLoaded = true;
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            }

          })
          .catch(function (error) {
            console.log(error);
          });
      },
      GetAccountValues(){
        var _this = this;
        axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
          .then(function (response) {
            _this.Account = response.data.raw;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      GetAccountBySalesForce(){
        var _this = this;
        _this.isDataLoading = true;

        axios.get('/Account/GetBySalesforceId/' + this.Order.accountId, {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
          .then(function (response) {
            _this.isDataLoading = false;
            _this.Account = response.data.raw;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      NewOrder(id){
        this.$router.push({name: 'Order',  params: {code:id, EditOrReuse: 2}});
      },
      EditOrder(id) {
        this.$router.push({name: 'Order',  params: {code:id, EditOrReuse: 0}});
      },
      ReuseOrder(id){
        this.$router.push({name: 'Order',  params: {code:id, EditOrReuse: 1}});
      },
      DeleteOrder(){
        var _this = this;
        this.isDeleteModelShown = false;
        var params = {
          Id: this.idToDelete
        };
        axios.post("/Order/Delete/", params, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
          .then(function (response) {
            _this.$router.push({name: 'OrderTracking'});
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      GenerateHtml(){
        var _this = this;
        var routeData = this.$router.resolve({name: 'ExamSummary', query: { orderId: _this.Order.id }});
        //window.open(routeData.href, '_top');
        window.open(routeData.href, '_blank', 'width=' + (parseInt(window.innerWidth)) + ', height=' + (parseInt(window.innerHeight)) + '');
      }

    },
    created(){
      this.MasterAccountType = localStorage.getItem("accountType");
      this.GetOrderData();
    }
  }
</script>



// WEBPACK FOOTER //
// ExamConfirmation.vue?ff3fa92e